import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeRunStatus, NodeRunStatusUtil } from 'src/app/domainObjects/nodeRunStatus';
import { RefineryStatus, RefineryStatusUtil } from 'src/app/domainObjects/refineryStatus';
import { NodedefinitionComponent } from 'src/app/nodedefinition/nodedefinition.component';

@Component({
    selector: 'app-about-this-node',
    templateUrl: './about-this-node.component.html',
    styleUrls: ['./about-this-node.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})


export class AboutThisNodeComponent {

  refineryName: string;
  nodeType: string;
  farmTypeColor: string;
  name: string;
  description: string;
  subtitle: string;
  farmtypeid: number;
  nodeboxtypeid: number;
  nodeStatus: number;
  created: string;
  lastSaved: string;
  lastRun: string;
  rowsIN: string;
  rowsOut: string;
  runTime:string;
  inputNode: string
  inputAttr: string
  transformerLabel: string

  transformerlist: string[];

  NodeRunStatus = NodeRunStatus;
  NodeRunStatusUtil = NodeRunStatusUtil;

     constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private dialogRef: MatDialogRef<AboutThisNodeComponent>) { }

  ngOnInit(): void {
    this.nodeStatus = this.data.nodeStatus ?? ' ';
    this.nodeType = this.data.nodeType ?? ' ';
    this.refineryName = this.data.refineryName ?? ' ';
    this.name = this.data.label ?? ' ';
    this.description = this.data.Descriptor ?? '';
    this.subtitle = this.data.subtitle ?? '';
    this.farmtypeid = this.data.farmtypeid ;
    this.nodeboxtypeid = this.data.nodeboxtypeid;
    this.farmTypeColor = this.data.farmTypeColor;
    this.created = this.data.created;
    this.lastSaved = this.data.lastSaved;
    this.lastRun = this.data.lastRun;
    this.rowsIN = this.data.rowsIN;
    this.rowsOut = this.data.rowsOut;
    this.runTime = this.data.runTime;
    this.inputNode = this.data.inputNode;
    this.inputAttr = this.data.inputAttr;
    this.transformerLabel=this.data.transformerLabel;

    this.transformerlist = this.subtitle.split('>');

    
  }

  // save(): void {
  //   this.dialogRef.close({name: this.name, description:this.description});
  // }

  cancel(): void {
    this.dialogRef.close();
  }

}
